import {NSFunctions} from './functions'


export let NSTables = {	
	
	/*
	var init = function()
	{

	}
	*/
	
	//---------------------------------
	
	//NSTables   ----------------------
	  aTables: new Array(), // [NSTables.Objs.Table]
	  getTableById: function (sID)
	  {
		var a = this.aTables;
		for(var i=0; i<a.length; i++)
		{
		  var oT = a[i];
		  if(oT.sTableId == sID)
			return oT;
		}  
	  },
	  removeTableById: function (sID)
	  {
		var a = this.aTables;
		for(var i=0; i<a.length; i++)
		{
		  var oT = a[i];
		  if(oT.sTableId == sID)
		  {
			a.splice(i, 1);      
			return;
		  }
		}  
	  },
	  //oTable -> NSTables.Objs.Table
	  addTable: function (oTable)
	  {
		this.aTables.push(oTable);
	  }
	}
	
	
	//NSTables.Objs   -----------------
	NSTables.Objs ={};
	
	/*
	o_in = {
		eHTMLHolder, 
		aColumns, 
		sTableCSS, 
		aTH_CSS, 
		aTD_CSS, 
		sTR_CSS, 
		sTR_SELECTED_CSS, 
		b_multiple_selection, 
		b_multiple_selection_classic_style, //windows classic behavior, default is true
		b_sortable,
		a_b_col_sortable,    // default b_sortable determines if all are sortable or not
		a_sort_cmp_function, //    ->  a[f(o1,o2)]    -> f returns true if o1 < o2 , default string comparisson...
	}
	*/
	NSTables.Objs.Table = function (o_in) 
	{	
		var this_ = this;
		
		var eHTMLHolder = o_in.eHTMLHolder;
		var aColumns = o_in.aColumns;
		var sTableCSS = o_in.sTableCSS;
		var aTH_CSS = o_in.aTH_CSS;
		var aTD_CSS = o_in.aTD_CSS;
		var sTR_CSS = o_in.sTR_CSS;
		var sTR_SELECTED_CSS = o_in.sTR_SELECTED_CSS;
		var b_multiple_selection = o_in.b_multiple_selection;
		var b_multiple_selection_classic_style = (o_in.b_multiple_selection_classic_style != null)? o_in.b_multiple_selection_classic_style: true;
		var b_sortable = o_in.b_sortable;
		var a_b_col_sortable = o_in.a_b_col_sortable;
		var a_sort_cmp_function = o_in.a_sort_cmp_function;

		
		sTableCSS = (sTableCSS != null)? sTableCSS: "nstables_table"; 
		aTH_CSS = (aTH_CSS != null)? aTH_CSS: ["nstables_th"];
		aTD_CSS = (aTD_CSS != null)? aTD_CSS: ["nstables_td"];
		sTR_CSS = (sTR_CSS != null)? sTR_CSS: ["nstables_tr"];
		sTR_SELECTED_CSS = (sTR_SELECTED_CSS != null)? sTR_SELECTED_CSS: ["nstables_row_selected"];
		var sTR_Hidden_CSS = "nstables_row_hidden";


		this.sTableId = NSFunctions.guidGenerator();
		
		this.b_multiple_selection = b_multiple_selection;
		this.b_multiple_selection_classic_style = b_multiple_selection_classic_style;
		
		this.aTD_CSS = aTD_CSS;
		this.eHTMLHolder = eHTMLHolder;
		this.e_Table;
		this.e_Table_thead;
		this.e_Table_tbody;
		this.a_rows_content = new Array();
		this.a_rows_keys = new Array();
		this.a_eHTML_tr = new Array();
		this.fRowClickEventCallBackFunction = null;
		this.aSelectedRows = new Array();
		this.i_last_single_select = 0;

		this.sTR_CSS = sTR_CSS;
		this.sTR_SELECTED_CSS = sTR_SELECTED_CSS;
		this.sTR_Hidden_CSS = sTR_Hidden_CSS; 
		
		/*
		<table style="width:300px">
			<thead>
				<tr>
					<th>Col1Heading</th>
					<th>Col2Heading</th>		
				<tr>
			</thead>
			<tbody>
				<tr>
					<td>Col1</td>
					<td>Col2</td>		
				</tr>
			</tbody>
		</table>
	  */
	  
		var e_Table = document.createElement('table');
		this.e_Table = e_Table;
		e_Table.setAttribute("class", sTableCSS);
		e_Table.setAttribute("id", this.sTableId);

		eHTMLHolder.appendChild(e_Table);

		var e_Table_thead = document.createElement('thead');
		this.e_Table_thead = e_Table_thead;
		e_Table.appendChild(e_Table_thead);

		var e_Table_tbody = document.createElement('tbody');
		this.e_Table_tbody = e_Table_tbody;
		e_Table.appendChild(e_Table_tbody);
		
		if(b_multiple_selection_classic_style)
		{
			e_Table.onmousedown = function (e_in)
			{
				var f_pauseEvent = function (e){
					if(e.stopPropagation) e.stopPropagation();
					if(e.preventDefault) e.preventDefault();
					e.cancelBubble=true;
					e.returnValue=false;
					return false;
				}
				
				if(e_in && e_in.shiftKey)
				{
					f_pauseEvent(e_in);
				}
				
			}
		}
		

	  
		var f_getF_ = function(e_, i_){
			return function()
			{
				var f_sort_cmp_function = (a_sort_cmp_function != null && a_sort_cmp_function[i_] != null) ?
					a_sort_cmp_function[i_] : null;
				
				this_.click_oCol(e_, f_sort_cmp_function);
			};
		};
	  
		var e_tr = document.createElement('tr');
		for(var i=0; i<aColumns.length; i++)
		{
			var e_th = document.createElement('th');
			
			var b_i_sortable = ( (b_sortable && a_b_col_sortable == null) 
				|| (b_sortable && a_b_col_sortable != null && ( a_b_col_sortable[i] == true || a_b_col_sortable[i] == null ))
				|| (a_b_col_sortable!=null && a_b_col_sortable[i]) )? true :false;
			
			var s_class = (b_i_sortable)? this.getCSSFromArray(aTH_CSS, i) + " sortable" : this.getCSSFromArray(aTH_CSS, i) ;
			e_th.setAttribute("class", s_class);
			e_th.setAttribute("col_index", i);
			e_th.setAttribute("sorted_asc", "");
			e_th.onclick = (b_i_sortable)? f_getF_(e_th, i) : null;

			var e_span_img_sort = document.createElement('span');
			e_span_img_sort.setAttribute("class", "glyphicon glyphicon-arrow-up"); //"glyphicon glyphicon-arrow-up" || "glyphicon glyphicon-arrow-down"
			e_span_img_sort.setAttribute("aria-hidden", "true");
			e_span_img_sort.style.visibility = "hidden";

			var e_span_col_text = document.createElement('span');
			e_span_col_text.innerHTML = aColumns[i];

			e_th.appendChild(e_span_img_sort);
			e_th.appendChild(e_span_col_text);

			e_tr.appendChild(e_th);   
		}  
		e_Table_thead.appendChild(e_tr);


		NSTables.addTable(this);

	}
	
	
	NSTables.Objs.Table.prototype.hideAllColumnsSortImage = function () 
	{
		var a_th = this.e_Table_thead.children[0].children; //this.e_Table_thead.getElementsByTagName('th');
		for(var i=0; i<a_th.length; i++)
		{
			var	e_span_img = a_th[i].children[0];
			e_span_img.style.visibility = "hidden";
		}
		
	}

	NSTables.Objs.Table.prototype.click_oCol = function(e_col, f_sort_cmp_function)
	{
		var s_colIndex = e_col.getAttribute("col_index");
		var s_sorted_asc = e_col.getAttribute("sorted_asc").toLowerCase();
		var i_colIndex = parseInt(s_colIndex);
		var	e_span_img = e_col.children[0];
		
		var b_sort_asc = (s_sorted_asc=="" || s_sorted_asc == "false")? true : false;
		
		//sorting
		this.orderByCol(i_colIndex, b_sort_asc, f_sort_cmp_function)
		
		//storing state
		var s_sorted_asc_new = (b_sort_asc)? "true" : "false";
		e_col.setAttribute("sorted_asc", s_sorted_asc_new);
		
		//displaying image
		this.hideAllColumnsSortImage();
		var s_class = (b_sort_asc)? "glyphicon glyphicon-arrow-up" : "glyphicon glyphicon-arrow-down";
		e_span_img.setAttribute("class", s_class);
		e_span_img.style.visibility = '';

	}

	NSTables.Objs.Table.prototype.destroy = function(){
	  
		NSTables.removeTableById(this.sTableId);
		this.eHTMLHolder.innerHTML = "";

		this.sTableId = null;
		
		this.aTD_CSS = null;
		this.eHTMLHolder = null;
		this.e_Table = null;
		this.e_Table_thead = null;
		this.e_Table_tbody = null;
		this.a_rows_content = null;
		this.a_rows_keys = null;
		this.a_eHTML_tr = null;
		this.fRowClickEventCallBackFunction = null;
		this.aSelectedRows = null;
		this.sTR_CSS = null;
		this.sTR_SELECTED_CSS = null; 
		
	}

	NSTables.Objs.Table.prototype.destroyContent = function(){
	  
		this.e_Table_tbody.innerHTML = "";
		this.a_rows_content = new Array();
		this.a_rows_keys = new Array();
		this.a_eHTML_tr = new Array();

		this.aSelectedRows = new Array();

	}
	
	 NSTables.Objs.Table.prototype.f_get_tr_by_row_key = function (s_row_key)
	 {
		var a_e_tr = this.e_Table_tbody.children
		for(var i=0; i<a_e_tr.length; i++)
		{
			var e_tr_i = a_e_tr[i];
			var s_row_key_i = e_tr_i.getAttribute("row_key");
			
			if(s_row_key == s_row_key_i)
			{
				return e_tr_i;
			}

		}
		
		return null;
	 }
	 
	 /*
		returns: {
			a_rows_content____current,		// [string]
			a_rows_keys____current,			// [[string]
		}
	 */
	 NSTables.Objs.Table.prototype.f_aux_get_current__a_rows_keys_and_a_rows_content = function ()
	 {
		var a_row_key = [];		// [string]
		var a_row_values = [];	// [[string]]

		var a_e_tr = this.e_Table_tbody.children
		for(var i=0; i<a_e_tr.length; i++)
		{
			var e_tr_i = a_e_tr[i];
			a_row_key.push(e_tr_i.getAttribute("row_key"));

			a_row_values.push([]);
			var a_e_td = e_tr_i.children;
			for(var j=0; j< a_e_td.length; j++)
			{
				var e_td_j = a_e_td[j];

				a_row_values[i].push(e_td_j.innerHTML);

			}
		}
	
		var o_res =
		{
			a_rows_keys____current: a_row_key,
			a_rows_content____current: a_row_values,
		}
		return o_res;
	 
	 }
	 /*
	 f_sort_cmp_function(o1, o2)){returns o1 < o2;}
	 */
	NSTables.Objs.Table.prototype.orderByCol = function(i_columnIndex, b_order_ascending, f_sort_cmp_function)
	{
		//var a_rows_keys_old = this.a_rows_keys;
		//var a_rows_content_old = this.a_rows_content;
		var o_a_rows_keys_content_current = this.f_aux_get_current__a_rows_keys_and_a_rows_content();
		var a_rows_keys_old = o_a_rows_keys_content_current.a_rows_keys____current;
		var a_rows_content_old = o_a_rows_keys_content_current.a_rows_content____current;
		
		var a_eHTML_tr_old = this.a_eHTML_tr;
		
		var a_selected_keys_old = this.getSelection_keys();
		
		//cleans selections
		this.selectRow_(-1);  
		
		
		var a_rows_content_new = new Array();
		var a_rows_keys_new = new Array();
		var a_eHTML_tr_new  = new Array();
		
		var f_o1_lessthan_o2;
		if(f_sort_cmp_function == null)
		{
			f_o1_lessthan_o2 = function(o1, o2)
			{
				return o1 < o2;	
			}
		}
		else
		{
			f_o1_lessthan_o2 = f_sort_cmp_function;
		}
		
		var f_position_valid = function (new_val, resident_val)
			{
				if (b_order_ascending)
				{
					return f_o1_lessthan_o2(new_val, resident_val);
				}
				else
				{
					return f_o1_lessthan_o2(resident_val, new_val);
				}
			}
		
		for(var i=0; i<a_rows_content_old.length; i++)
		{
			var o_row_i = a_rows_content_old[i];
			var o_col_val = o_row_i[i_columnIndex];
			
			var j=0;
			while( (a_rows_content_new[j] != null) && (!f_position_valid(o_col_val, a_rows_content_new[j][i_columnIndex])) )
			{
				j++;
			}
			a_rows_content_new.splice(j, 0, o_row_i);
			a_rows_keys_new.splice(j, 0, a_rows_keys_old[i]);
			a_eHTML_tr_new.splice(j, 0, a_eHTML_tr_old[i]);
		}
		
		
		/*
		this old version would detroy old elements and rebuild everything
		
		//cleaning table
		this.destroyContent();
		
		//adding new content
		var oDT = new NSTables.Objs.DataTable();
		oDT.addRows(a_rows_content_new, a_rows_keys_new);

		this.addRows(oDT);
		*/
		
		this.f_sort_tr_by_a_row_key_(a_rows_keys_new, a_rows_content_new, a_eHTML_tr_new);
		
		this.setSelection_byKey(a_selected_keys_old);
		

	}
	
	 NSTables.Objs.Table.prototype.f_sort_tr_by_a_row_key_ = function (a_rows_keys_new, a_rows_content_new, a_eHTML_tr_new)
	 {
		var e_Table_tbody = this.e_Table_tbody;
		var a_e_tr = e_Table_tbody.children;
		
		
		//creating an backup array of e_tr whilw removing them from table
		var a_e_tr_bkp = [];
		while (e_Table_tbody.children.length > 0)
		{
			a_e_tr_bkp.push(e_Table_tbody.removeChild(e_Table_tbody.children[0]))
		}
		
		//func to get e_tr from backup array by row_key
		var f_get_e_tr_by_row_key = function (s_row_key)
		{
			var e_tr = null;
			
			for(var i=0; i<a_e_tr_bkp.length; i++)
			{
				var o_e_tr_i = a_e_tr_bkp[i];
				if(o_e_tr_i.getAttribute("row_key") == s_row_key)
				{
					//removes and returns removed obj
					e_tr = a_e_tr_bkp.splice(i,1)[0];
					break;
				}
			}
			
			return e_tr;
		}
		
		//Appending to table e_tr by new order
		var i_row_index = 0;
		for (var i=0; i<a_rows_keys_new.length; i++)
		{
			var s_row_key_i = a_rows_keys_new[i];
			var e_tr_i = f_get_e_tr_by_row_key(s_row_key_i);
			e_tr_i.setAttribute("row_index", i);
			
			e_Table_tbody.appendChild(e_tr_i);
			
		}
		
		//updating internal structures:
		this.a_rows_keys = a_rows_keys_new;
		this.a_rows_content = a_rows_content_new;
		this.a_eHTML_tr = a_eHTML_tr_new;	

		
	 }


	//aCSS -> ex: [str1, str2,...], this array length must be >= 1
	//Tries to get the CSS from position iPos in ther given array, but if the array only 
	//    has one element, it'll be returned 
	NSTables.Objs.Table.prototype.getCSSFromArray = function(aCSS, iPos){
	  var i = (aCSS.length > 1)? iPos : 0;
		return aCSS[i];  	
	};

	//aRowValues -> ex: [str1, str2, strHTML]
	NSTables.Objs.Table.prototype.addRow_ = function(aRowValues, sKey){
	  var this_ = this;
	  
	  var e_tr = document.createElement('tr');
	  e_tr.setAttribute("class", this.sTR_CSS);
	  
	  for(var i=0; i<aRowValues.length; i++)
	  {
		var e_td = document.createElement('td');
		e_td.setAttribute("class", this.getCSSFromArray(this.aTD_CSS, i) );
		e_td.innerHTML = aRowValues[i];
		e_tr.appendChild(e_td);   
	  }
		
	  e_tr.setAttribute("row_index", this.a_eHTML_tr.length);
	  e_tr.setAttribute("row_key", sKey);
	  
	  e_tr.onclick = function(o_event){
			var e_tr_param = this;
			this_.rowClickEvent_(e_tr_param, o_event);
		}
	  this.a_eHTML_tr.push(e_tr);
	  this.a_rows_content.push(aRowValues);
	  this.a_rows_keys.push(sKey);
	  this.e_Table_tbody.appendChild(e_tr);
		
	};

	//oDataTable -> NSTables.Objs.DataTable
	NSTables.Objs.Table.prototype.addRows = function(oDataTable){
	  var aRows = oDataTable.a;
	  var a_keys = oDataTable.a_keys;

	  for(var i=0; i<aRows.length; i++)
	  {
		var aRowValues = aRows[i];
		var sKey = a_keys[i];
		
		this.addRow_(aRowValues, sKey);
	  
	  }
			
	};

	//aRowValues -> ex: [str1, str2, strHTML]
	NSTables.Objs.Table.prototype.refreshCellContent_ = function(iRow, iColumn, cellContent){

	  var e = this.e_Table_tbody.childNodes[iRow].childNodes[iColumn];
	  e.innerHTML = cellContent;
		
	};

	//oDataTable -> NSTables.Objs.DataTable
	NSTables.Objs.Table.prototype.refreshCellContent = function(iRow, iColumn, oDataTable){
	  var aRows = oDataTable.a;
	  
	  this.a_rows_content[iRow][iColumn] = aRows[iRow][iColumn];
	  
	  var cellContent = aRows[iRow][iColumn];
	  this.refreshCellContent_(iRow, iColumn, cellContent);
			
	};

	NSTables.Objs.Table.prototype.unselectAllRows = function()
	{
		//this.setSelectedRow(-1);
		this.selectRow_(-1);
	}
	NSTables.Objs.Table.prototype.getSelection_keys = function()
	{
		var a_selected_keys = new Array();
		for(var i=0; i<this.aSelectedRows.length; i++)
		{
			a_selected_keys.push(this.a_rows_keys[this.aSelectedRows[i]]);
		}
		return a_selected_keys;
	} 
	//returns an integer array with the selected indexes
	NSTables.Objs.Table.prototype.getSelection = function()
	{
	  return this.aSelectedRows;
	} 
	NSTables.Objs.Table.prototype.setSelection_byKey = function(a_keys_in)
	{
		var a_rows_indexes = new Array();
		
		var a_rows_keys = this.a_rows_keys;
		for(var i=0; i<a_keys_in.length; i++)
		{
			var i_row_index = a_rows_keys.indexOf(a_keys_in[i]);
			a_rows_indexes.push(i_row_index);
		}
		
		this.setSelection(a_rows_indexes);
		
	}
	//a_i_Rows -> [int]
	NSTables.Objs.Table.prototype.setSelection = function(a_i_Rows)
	{
		if(this.b_multiple_selection)
		{
			if((a_i_Rows!=null) && (a_i_Rows.length>0))
			{
				for(var i=0; i<a_i_Rows.length; i++)
				{
					this.selectAnotherRow_(a_i_Rows[i]);
				}
			}
			else
			{
				//cleans selections
				this.selectRow_(-1);  
			}
		}
		else
		{
			var iRow = ((a_i_Rows!=null) && (a_i_Rows.length>0))? a_i_Rows[0] : -1;
			this.selectRow_(iRow);  
		}
		
	}
	// this function does not triger the callback event
	// iRow -> (null||<0) to unselect all rows
	NSTables.Objs.Table.prototype.setSelectedRow = function(iRow)
	{
		
		if(this.b_multiple_selection)
		{
			this.selectAnotherRow_(iRow);
		}
		else
		{
			this.selectRow_(iRow);
		}
	}

	//selects an unique row
	NSTables.Objs.Table.prototype.selectRow_ = function(iRow)
	{
	  var a_eHTML_tr = this.a_eHTML_tr;
	  
	  for(var i=0; i<a_eHTML_tr.length; i++)
	  {
	  
		var e_HTML_tr = a_eHTML_tr[i];
		var sClasses = e_HTML_tr.getAttribute("class");
		if(i != iRow)
		{
		  sClasses = this.elemClass_RemoveClass_(sClasses, this.sTR_SELECTED_CSS);
		  NSFunctions.removeValueFromArray(this.aSelectedRows , i);
		}  
		else
		{
		  if( this.elemClass_HasClass_(sClasses, this.sTR_SELECTED_CSS) )
		  {
			sClasses = this.elemClass_RemoveClass_(sClasses, this.sTR_SELECTED_CSS);
			this.aSelectedRows = [];      
		  }
		  else
		  {
			sClasses = this.elemClass_addClass_(sClasses, this.sTR_SELECTED_CSS);        
			this.aSelectedRows = [iRow];      
		  }   
		}
		e_HTML_tr.setAttribute("class", sClasses);
				  
	  }
		
	}

	NSTables.Objs.Table.prototype.selectAnotherRow_ = function(iRow)
	{
		var a_eHTML_tr = this.a_eHTML_tr;
	  
		for(var i=0; i<a_eHTML_tr.length; i++)
		{

			var e_HTML_tr = a_eHTML_tr[i];
			var sClasses = e_HTML_tr.getAttribute("class");
			if(i != iRow)
			{
				//do nothing
			}  
			else
			{
				if( this.elemClass_HasClass_(sClasses, this.sTR_SELECTED_CSS) )
				{
					sClasses = this.elemClass_RemoveClass_(sClasses, this.sTR_SELECTED_CSS);
					NSFunctions.removeValueFromArray(this.aSelectedRows , iRow);
				}
				else
				{
					sClasses = this.elemClass_addClass_(sClasses, this.sTR_SELECTED_CSS);        
					this.aSelectedRows.push(iRow);      
				}   
			}
			e_HTML_tr.setAttribute("class", sClasses);
				  
	  }

	}

	//  aRowIndex ->  [int]
	NSTables.Objs.Table.prototype.hideRows = function(aRowIndex)
	{

	  var a_eHTML_tr = this.a_eHTML_tr;
	  
	  for(var i=0; i<aRowIndex.length; i++)
	  {
		var iRow = aRowIndex[i];
		var e_HTML_tr = a_eHTML_tr[iRow];
		var sClasses = e_HTML_tr.getAttribute("class");
		if( !(this.elemClass_HasClass_(sClasses, this.sTR_Hidden_CSS)) )
		{
		  sClasses = this.elemClass_addClass_(sClasses, this.sTR_Hidden_CSS);    
		  e_HTML_tr.setAttribute("class", sClasses);
		}          
	  }
		
	}

	//  aRowIndex ->  [int]
	NSTables.Objs.Table.prototype.showRows = function(aRowIndex)
	{

	  var a_eHTML_tr = this.a_eHTML_tr;
	  
	  for(var i=0; i<aRowIndex.length; i++)
	  {
		var iRow = aRowIndex[i];
		var e_HTML_tr = a_eHTML_tr[iRow];
		var sClasses = e_HTML_tr.getAttribute("class");
		sClasses = this.elemClass_RemoveClass_(sClasses, this.sTR_Hidden_CSS);    
		e_HTML_tr.setAttribute("class", sClasses);
				  
	  }
		  
	}
	NSTables.Objs.Table.prototype.showAllRows = function()
	{

	  var a_eHTML_tr = this.a_eHTML_tr;
	  
	  for(var i=0; i<a_eHTML_tr.length; i++)
	  {
		var e_HTML_tr = a_eHTML_tr[i];
		var sClasses = e_HTML_tr.getAttribute("class");
		sClasses = this.elemClass_RemoveClass_(sClasses, this.sTR_Hidden_CSS);    
		e_HTML_tr.setAttribute("class", sClasses);
				  
	  }
		  
	}

	//returns true if HTML Class list string has the passed class
	NSTables.Objs.Table.prototype.elemClass_HasClass_ = function (sClassesList, sClass)
	{
	  if(sClassesList.indexOf(sClass)>-1)
		return true;
	  else
		return false;
	}
	//returns a string, with the passed class(sClass) removed from the HTML Class list string(sClassesList)
	NSTables.Objs.Table.prototype.elemClass_RemoveClass_ = function (sClassesList, sClass)
	{
		
		sClassesList = sClassesList.replace(sClass, "");
	  sClassesList = sClassesList.replace("  ", "");
	  return sClassesList;
	  
	}
	NSTables.Objs.Table.prototype.elemClass_addClass_ = function (sClassesList, sClass)
	{
	  
		sClassesList = (sClassesList.length > 0)? sClassesList + " " + sClass : sClass;
	  return sClassesList;
	  
	}

	//fCallBack(i) -> function to be called back on row click event
	//          i  -> this parameter will be the index of the clicked row
	NSTables.Objs.Table.prototype.addRowClickEventFunction = function(fCallBack){
	  this.fRowClickEventCallBackFunction = fCallBack;
	}

	NSTables.Objs.Table.prototype.rowClickEvent_ = function(e_tr, o_event){
		//e_tr -> tr Element
		//this == oTable
		var iClickedRowIndex = parseInt(e_tr.getAttribute("row_index"));
		var sTableId = e_tr.parentElement.parentElement.getAttribute("id");

		var oTable = NSTables.getTableById(sTableId);

		if(this.b_multiple_selection)
		{
			//this.selectAnotherRow_(iClickedRowIndex);
			this.f_handle_multiple_selection_(iClickedRowIndex, o_event);
		}
		else
		{
			oTable.selectRow_(iClickedRowIndex);
		}
	  
		oTable.fRowClickEventCallBackFunction(iClickedRowIndex);
		
	};

	NSTables.Objs.Table.prototype.f_handle_multiple_selection_ = function(iClickedRowIndex, o_event)
	{
	/*
		b_multiple_selection
		b_multiple_selection_classic_style
		
		aSelectedRows
		i_last_single_select

		
		event.ctrlKey
		event.shiftKey
	*/
		var aSelectedRows = this.aSelectedRows;
		var b_multiple_selection_classic_style = this.b_multiple_selection_classic_style;
		var b_ClickedRow_was_already_selected = (aSelectedRows.indexOf(iClickedRowIndex)>-1)? true: false;
		
		//single selection
		if(!event.shiftKey)
		{
			if(!event.ctrlKey)
			{
				if(b_multiple_selection_classic_style)
				{
					this.unselectAllRows();
					if(!b_ClickedRow_was_already_selected)
					{
						this.setSelectedRow(iClickedRowIndex);
					}				
				}
				else
				{
					this.setSelectedRow(iClickedRowIndex);
				}
			}
			else
			{
				this.setSelectedRow(iClickedRowIndex);// with multiple selection adds another row to the already selected
			}
			//this.i_last_single_select = (b_ClickedRow_was_already_selected)? 0 : iClickedRowIndex;
			this.i_last_single_select = iClickedRowIndex;
			
		}
		else//multiple selection
		{
			if(!event.ctrlKey)
			{
				this.unselectAllRows();
			}
			var a_new_selection = aSelectedRows.slice(0);// copy of array aSelectedRows
			
			var i_min = Math.min(this.i_last_single_select, iClickedRowIndex);
			var i_max = Math.max(this.i_last_single_select, iClickedRowIndex);
			for(var i=i_min; i<=i_max; i++)
			{
				if(a_new_selection.indexOf(i)==-1)
				{
					a_new_selection.push(i);	
				}			
			}
			this.unselectAllRows();
			this.setSelection(a_new_selection);

		}

	};


	NSTables.Objs.DataTable = function ()
	{
	  this.a = new Array();
	  this.a_keys = new Array();
	}
	//a_a_row ->  ex1: [[1,2]]  ex2: [[1,2], [2,3]]  
	NSTables.Objs.DataTable.prototype.addRows = function (a_a_row, a_keys)
	{
	  this.a = this.a.concat(a_a_row);
	  this.a_keys = this.a_keys.concat(a_keys);
	}  
	NSTables.Objs.DataTable.prototype.getValue = function(iRow, iCol)
	{
	  return this.a[iRow][iCol];
	}
	NSTables.Objs.DataTable.prototype.getValue_byKey = function(sKey, iCol)
	{
		for(var i=0; i<this.a_keys.length; i++)
		{
			if(this.a_keys[i] == sKey)
			{
				var iRow = i;
				return this.a[iRow][iCol];	
			}
		}
		return null;
	}
	//  iCol    -> index of Column to be evaluated
	//  [oVal]    -> value that wanted rows have (simple type like string int or float)
	//  f_objComparison(obj1, obj2) -> OPTIONAL Parameter, function that compares 2 objects and returns true if they're equivalent 
	//returns   -> [int]
	NSTables.Objs.DataTable.prototype.getRowsWhereColVal_Is = function (iCol, a_oVal, f_objComparison)
	{
	  var f_compare = (f_objComparison != null)? f_objComparison : function(o1,o2){return o1==o2;};

	  var aRowsIndexes = new Array();
	  for (var iRow=0; iRow<this.a.length; iRow++)
	  {
		for(var j=0; j<a_oVal.length; j++)
		{
		  var oVal = a_oVal[j];
		  if(f_compare(this.a[iRow][iCol], oVal))
		  {
			aRowsIndexes.push(iRow);    
		  }   
		}
		
	  }
	  return aRowsIndexes; 
	}

	
	//---------------------------------
		/*
		NSTables:
		
		getTableById,
		removeTableById,
		addTable,
		
		Objs, contains Table and DataTable objects
			Table functions:
				hideAllColumnsSortImage
				click_oCol
				destroy
				destroyContent
				orderByCol
				getCSSFromArray
				addRows
				refreshCellContent
				unselectAllRows
				getSelection_keys
				getSelection
				setSelection
				setSelectedRow
				hideRows
				showRows
				showAllRows
				addRowClickEventFunction

			DataTable functions:
				addRows
				getValue
				getValue_byKey
				getRowsWhereColVal_Is
		
		*/

	





